export const SET_ORGANIZATION = "SET_ORGANIZATION";
export const GET_ORGANIZATION = "GET_ORGANIZATION";
